// extracted by mini-css-extract-plugin
export var avatarContainer = "_4r-0";
export var gray = "_4r-f";
export var green = "_4r-c";
export var icon = "_4r-9";
export var image = "_4r-1";
export var lg = "_4r-6";
export var md = "_4r-5";
export var presenceDot = "_4r-b";
export var red = "_4r-d";
export var sm = "_4r-4";
export var status = "_4r-a";
export var xl = "_4r-7";
export var xs = "_4r-3";
export var xxl = "_4r-8";
export var xxs = "_4r-2";
export var yellow = "_4r-e";